import React, { useState } from "react";
import { BeatLoader } from "react-spinners";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import tokenService from "../../../../utils/tokenService";

export function LoginSystem() {
  const [isUploading, setIsUploading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const profileImageUser = localStorage.getItem("profile_user");
  const LocalStorageUserLoggedData = localStorage.getItem("194aa3da_username");
  const LocalStoragePasswordLoggedData = localStorage.getItem("194aa3da_password");

  // Function to check if "redirectBack" is in the URL
  function shouldRedirectBack() {
    const urlParams = new URLSearchParams(window.location.search);
    const isRedirectBack = urlParams.get("redirectBack") === "true";
    console.log("Should redirect back:", isRedirectBack); // Logs true or false based on URL parameter
    return isRedirectBack;
  }

  // Function to handle redirection or closing the window after login
  function handlePostLoginRedirect() {
    console.log('🔍 handlePostLoginRedirect called');
    console.log('🔍 shouldRedirectBack():', shouldRedirectBack());
    
    try {
      if (shouldRedirectBack()) {
        console.log('🔄 Closing window...');
        window.close(); // Close the current tab if "redirectBack" is true
      } else {
        console.log('🔄 Redirecting to /home...');
        
        // Try multiple redirect methods for better compatibility
        if (window.location.replace) {
          window.location.replace("/home");
        } else if (window.location.href) {
          window.location.href = "/home";
        } else {
          // Fallback for edge cases
          window.location = "/home";
        }
        
        console.log('✅ Redirect command executed');
      }
    } catch (error) {
      console.error('❌ Redirect error:', error);
      
      // Force redirect as fallback
      setTimeout(() => {
        window.location = "/home";
      }, 100);
    }
  }

  function handleValidatePermission(e) {
    setIsUploading(true);
    e.preventDefault();

    axios
      .post(`${process.env.REACT_APP_API}/auth/login`, {
        uname: username.trim(),
        password: password,
      })
      .then((res) => {
        console.log('✅ Login successful:', res.data);
        const uidOfUser = res.data.uid;
        const token = res.data.token;
        
        if (!token) {
          console.error('❌ No token received from backend');
          setIsUploading(false);
          Swal.fire("เกิดข้อผิดพลาด!", "ไม่ได้รับ Token จากระบบ", "error");
          return;
        }

        // Use token service for proper token management
        const tokenSet = tokenService.setToken(token, uidOfUser);
        console.log('🔐 Token set result:', tokenSet);
        
        // Keep old localStorage for compatibility
        localStorage.setItem("194aa3da_username", username);
        localStorage.setItem("194aa3da_password", password);
        
        // Verify token was set correctly
        const verifyToken = tokenService.getToken();
        console.log('🔍 Token verification:', verifyToken ? 'Found' : 'Not Found');
        const verifyUID = tokenService.getUserId();
        console.log('🔍 UID verification:', verifyUID || 'Not Found');
        
        console.log('🔄 Redirecting in 2 seconds...');
        setTimeout(() => {
          setIsUploading(false);
          console.log('🚀 Executing redirect...');
          handlePostLoginRedirect();
        }, 2000); // Reduced from 3000 to 2000
      })
      .catch((err) => {
        setIsUploading(false);
        console.error('❌ Login error:', err);
        
        if (err.response && err.response.data && err.response.data.Error) {
          Swal.fire("เกิดข้อผิดพลาด!", `${err.response.data.Error}`, "warning");
        } else if (err.message) {
          Swal.fire("เกิดข้อผิดพลาด!", `${err.message}`, "warning");
        } else {
          Swal.fire("เกิดข้อผิดพลาด!", "ไม่สามารถเข้าสู่ระบบได้ กรุณาลองใหม่", "warning");
        }
      });
  }

  function sendLocalUserData(e) {
    e.preventDefault();
    setIsUploading(true);

    localStorage.setItem("194aa3da_username", LocalStorageUserLoggedData);
    localStorage.setItem("194aa3da_password", LocalStoragePasswordLoggedData);

    axios
      .post(`${process.env.REACT_APP_API}/auth/login`, {
        uname: LocalStorageUserLoggedData,
        password: LocalStoragePasswordLoggedData,
      })
      .then((res) => {
        const token = res.data.token;
        const uidOfUser = res.data.uid;

        // Use token service for proper token management
        tokenService.setToken(token, uidOfUser);
        
        setTimeout(() => {
          setIsUploading(false);
          handlePostLoginRedirect();
        }, 3000);
      })
      .catch((err) => {
        setIsUploading(false);
        Swal.fire("เกิดข้อผิดพลาด!", `${err.response.data.Error}`, "warning");
      });
  }

  return (
    <main
      className="w-full h-screen bg-cover bg-center flex items-center justify-center"
      style={{
        backgroundImage: "url('/bg-login.jpg')",
      }}
    >
      <motion.div
        className="bg-white bg-opacity-80 backdrop-blur-md backdrop-filter w-full max-w-4xl p-8 rounded-lg shadow-2xl border-2 border-white border-opacity-40 flex flex-col md:flex-row"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 2, ease: "easeInOut" }}
      >
        <div className="md:w-1/2 flex flex-col justify-center p-4 md:p-8">
          <h1 className="text-4xl font-bold text-center text-blue-500">PostPerty.com</h1>
          <h3 className="text-lg md:text-2xl mt-4 text-center">
            แพลตฟอร์ม ซื้อขาย อสังหาฯ บน
          </h3>
          <h3 className="text-lg md:text-2xl  text-center">
          แผนที่ ดูบ้านได้แบบ VR 3D 
          </h3>

          <h3 className="text-lg md:text-2xl  text-center">
        ช่วยชวน ช่วยชี้ ช่วยแชร์ ได้ค่าคอมฯ
          </h3>
        </div>
        <div className="md:w-1/2 flex flex-col justify-center p-4 md:p-8">
          <div className="flex flex-col items-center">
            <h1 className="text-2xl text-center text-blue-500 mb-2.5">
              ยินดีต้อนรับ {isUploading ? <BeatLoader color="#1D4ED8" /> : LocalStorageUserLoggedData}
            </h1>
            <h1 className="mb-2.5">แตะที่รูป Profile เพื่อเข้าระบบด่วน</h1>

            {profileImageUser && (
              <div
                className="w-24 h-24 bg-white rounded-full overflow-hidden cursor-pointer"
                onClick={sendLocalUserData}
              >
                <img
                  src={profileImageUser || "https://postpertybucket01.oss-ap-southeast-7.aliyuncs.com/official.png"}
                  className="w-full h-full object-cover"
                  alt="User Profile"
                />
              </div>
            )}
          </div>
          <form className="mt-8 space-y-4" onSubmit={handleValidatePermission}>
            <div>
              <label className="block text-gray-700">ชื่อผู้ใช้งาน (username)</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="username"
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
              />
            </div>
            <div className="relative">
              <label className="block text-gray-700">รหัสผ่าน (password)</label>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="password"
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-8 transform"
              >
                <img
                  src={
                    showPassword
                      ? "https://cdn-icons-png.flaticon.com/512/2767/2767194.png"
                      : "https://cdn-icons-png.flaticon.com/512/2767/2767146.png"
                  }
                  alt="Toggle Password Visibility"
                  className="w-6 h-6"
                />
              </button>
            </div>
            <div className="flex justify-between items-center mt-4">
              <Link to="/reset_password" className="text-blue-500 underline">
                ถ้าคุณลืมรหัสผ่าน คลิกที่นี่
              </Link>
            </div>
            <button
              type="submit"
              className="w-full py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              เข้าสู่ระบบ
            </button>
            <Link to="/register">
              <div className="w-full py-2 bg-yellow-500 text-black text-center rounded-lg hover:bg-yellow-700 transition-colors mt-4">
                สมัครสมาชิก
              </div>
            </Link>
          </form>
        </div>
      </motion.div>
    </main>
  );
}
